import Vue from 'vue'
import Clipboard from 'v-clipboard'
import qs from 'qs'
import AntdLaravel from '../antd-pro/laravel'
import {enquireScreen} from "./util"
import JsonExcel from 'vue-json-excel'

Vue.component('DownloadExcel', JsonExcel)

require('./bootstrap')

Vue.use(require('ant-design-vue'))
Vue.use(require('vue-shortkey'), { prevent: [ 'input', 'textarea' ] })
Vue.use(Clipboard)

Vue.prototype.$http = window.axios.create()
Vue.prototype.$laravel = window.Laravel
Vue.prototype.$qs = qs

const files = require.context('../antd-pro', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

const components = require.context('./components', true, /\.vue$/i)
components.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], components(key).default))

Vue.mixin(AntdLaravel)
Vue.mixin({
    created() {
        enquireScreen(isMobile => this.setDevice(isMobile))
    },
    computed: {
        isMobile() {
            return this.is_mobile
        }
    },
    methods: {
        setDevice(mobile) {
            this.is_mobile = mobile
        }
    }
})

new Vue({
    data: () => ({
        is_mobile: false
    })
}).$mount('#app')
